export enum RegistrationCookieKeys {
    ShowPhoneNumberSignup = 'vinovest-pn'
}
